import { Row } from "@tanstack/react-table";
import moment from "moment/moment";
import { User } from "@/services/cloudchipr.api";

export const usersLastLoginSortingFn = (
  currentRow: Row<User>,
  nextRow: Row<User>,
) => {
  const current = currentRow.original.last_time_logged_in_at;
  const next = nextRow.original.last_time_logged_in_at;

  if (!current || moment(current).isBefore(moment(next))) {
    return 1;
  }

  return -1;
};
